import React, { useState, useEffect } from "react";

import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
const SettingsPage = () => {

    const token = localStorage.getItem("token");

    const [mode, setMode] = useState("view");
    const navigate = useNavigate();
    const [company, setCompany] = useState({
        companyName: "",
        email: "",
        leaveEmail: "",
        smtpPassword: "",
        contactNumber: "",
        website: "",
        taxId: "",
        address: "",
        description: "",
        financialYear: "",
        logo: null,
        logoPreview: null
    });

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/company-info/all`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .then(data => {

                if (data.length > 0) {

                    const info = data[0];

                    setCompany({
                        ...info,
                        logo: null,
                        logoPreview: info.logoPath
                            ? `${API_BASE_URL}/${info.logoPath}`
                            : null
                    });

                    setMode("view");

                } else {

                    // No company exists → open form in add mode
                    setMode("add");

                }

            });

    }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    
        if (!token) {
          toast.error("You must be logged in to access this page.");
          navigate("/");
          return;
        }
    
        // ✅ check admin role
        if (!roles.includes("ROLE_ADMIN")) {
          toast.error("You are not authorized to access this page.");
          navigate("/");
          return;
        }
      }, [navigate]);

    const handleChange = (e) => {
        setCompany({
            ...company,
            [e.target.name]: e.target.value
        });
    };

    const handleLogoUpload = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setCompany({
            ...company,
            logo: file,
            logoPreview: URL.createObjectURL(file)
        });

    };

    const handleSave = () => {

        const formData = new FormData();

        formData.append(
            "companyInfo",
            new Blob(
                [JSON.stringify(company)],
                { type: "application/json" }
            )
        );

        if (company.logo) {
            formData.append("logo", company.logo);
        }

        fetch(`${API_BASE_URL}/api/company-info/save`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        })
            .then(res => res.json())
            .then(() => {
                alert("Saved Successfully");
                setMode("view");
            });

    };

    const buildFinancialYear = (startMonth, endMonth, startYear) => {

        if (!startMonth || !endMonth || !startYear) return "";

        const endYear =
            ["January", "February", "March"].includes(endMonth)
                ? parseInt(startYear) + 1
                : parseInt(startYear);

        return `${startMonth} ${startYear} – ${endMonth} ${endYear}`;

    };

    return (
        <>
            <AdminNavbar />

            <div className="container-fluid mt-4">

                {/* HEADER */}


                <div className="mb-3">

                    <h4 className="mb-2">
                        <i className="bi bi-building"></i> Company Information
                    </h4>

                    <div>

                        {/* ADD COMPANY BUTTON */}
                        {mode === "view" && !company.companyName && (
                            <button
                                className="btn btn-success me-2"
                                onClick={() => setMode("add")}
                            >
                                Add Company
                            </button>
                        )}

                        {/* SAVE BUTTON */}
                        {(mode === "edit" || mode === "add") && (
                            <button
                                className="btn btn-primary me-2"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}

                        {/* CANCEL BUTTON */}
                        {(mode === "edit" || mode === "add") && (
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => setMode("view")}
                            >
                                Cancel
                            </button>
                        )}

                        {/* EDIT BUTTON */}
                        {mode === "view" && (
                            <>

                                {company.companyName && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => setMode("edit")}
                                    >
                                        Edit
                                    </button>
                                )}

                                <button
                                    className="btn btn-secondary me-2"
                                    onClick={() => navigate(-1)}
                                >
                                    Back
                                </button>

                            </>
                        )}


                    </div>

                </div>



                {/* PRIMARY INFORMATION */}

                <div className="card mb-4">

                    <div className="card-header fw-semibold">
                        Primary Information
                    </div>

                    <div className="card-body">

                        <div className="row g-3">

                            {/* LOGO */}

                            <div className="col-md-2 text-center">

                                <label className="fw-semibold">Company Logo</label>

                                {company.logoPreview && (
                                    <img
                                        src={company.logoPreview}
                                        alt="logo"
                                        className="d-block mx-auto mb-2"
                                        style={{
                                            width: 120,
                                            height: 120,
                                            objectFit: "contain",
                                            border: "1px solid #ddd",
                                            borderRadius: 8
                                        }}
                                    />
                                )}

                                {mode !== "view" && (
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={handleLogoUpload}
                                    />
                                )}

                            </div>

                            {/* COMPANY NAME */}

                            <div className="col-md-3">
                                <label className="fw-semibold">Company Name</label>
                                <input
                                    className="form-control"
                                    name="companyName"
                                    value={company.companyName || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                            {/* EMAIL */}

                            <div className="col-md-3">
                                <label className="fw-semibold">Email</label>
                                <input
                                    className="form-control"
                                    name="email"
                                    value={company.email || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                            {/* CONTACT */}

                            <div className="col-md-3">
                                <label className="fw-semibold">Contact Number</label>
                                <input
                                    className="form-control"
                                    name="contactNumber"
                                    value={company.contactNumber || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                        </div>

                    </div>

                </div>

                {/* EMAIL | PHONE */}

                <div className="card mb-4">

                    <div className="card-header fw-semibold">
                        Email | Phone
                    </div>

                    <div className="card-body">

                        <div className="row g-3">

                            <div className="col-md-3">
                                <label className="fw-semibold">Leave Email</label>
                                <input
                                    className="form-control"
                                    name="leaveEmail"
                                    value={company.leaveEmail || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="fw-semibold">Website</label>
                                <input
                                    className="form-control"
                                    name="website"
                                    value={company.website || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>


                            <div className="col-md-4">

                                <label className="fw-semibold">Financial Year</label>

                                <div className="d-flex gap-2">

                                    {/* Start Month */}
                                    <select
                                        className="form-select"
                                        value={company.startMonth || ""}
                                        disabled={mode === "view"}
                                        onChange={(e) => {

                                            const startMonth = e.target.value;

                                            const fy = buildFinancialYear(
                                                startMonth,
                                                company.endMonth,
                                                company.startYear
                                            );

                                            setCompany({
                                                ...company,
                                                startMonth,
                                                financialYear: fy
                                            });

                                        }}
                                    >
                                        <option value="">Start Month</option>
                                        {[
                                            "January", "February", "March", "April", "May", "June",
                                            "July", "August", "September", "October", "November", "December"
                                        ].map(m => (
                                            <option key={m}>{m}</option>
                                        ))}
                                    </select>

                                    {/* End Month */}
                                    <select
                                        className="form-select"
                                        value={company.endMonth || ""}
                                        disabled={mode === "view"}
                                        onChange={(e) => {

                                            const endMonth = e.target.value;

                                            const fy = buildFinancialYear(
                                                company.startMonth,
                                                endMonth,
                                                company.startYear
                                            );

                                            setCompany({
                                                ...company,
                                                endMonth,
                                                financialYear: fy
                                            });

                                        }}
                                    >
                                        <option value="">End Month</option>
                                        {[
                                            "January", "February", "March", "April", "May", "June",
                                            "July", "August", "September", "October", "November", "December"
                                        ].map(m => (
                                            <option key={m}>{m}</option>
                                        ))}
                                    </select>

                                    {/* Year */}
                                    <select
                                        className="form-select"
                                        value={company.startYear || ""}
                                        disabled={mode === "view"}
                                        onChange={(e) => {

                                            const startYear = e.target.value;

                                            const fy = buildFinancialYear(
                                                company.startMonth,
                                                company.endMonth,
                                                startYear
                                            );

                                            setCompany({
                                                ...company,
                                                startYear,
                                                financialYear: fy
                                            });

                                        }}
                                    >
                                        <option value="">Year</option>

                                        {Array.from({ length: 6 }).map((_, i) => {
                                            const year = new Date().getFullYear() - 2 + i;
                                            return <option key={year}>{year}</option>;
                                        })}

                                    </select>

                                </div>

                                {company.financialYear && (
                                    <small className="text-muted">
                                        {company.financialYear}
                                    </small>
                                )}

                            </div>



                        </div>

                    </div>

                </div>

                {/* OTHER INFORMATION */}

                <div className="card mb-4">

                    <div className="card-header fw-semibold">
                        Other Information
                    </div>

                    <div className="card-body">

                        <div className="row g-6">

                            <div className="col-md-4">
                                <label className="fw-semibold">GST / Tax ID</label>
                                <input
                                    className="form-control"
                                    name="taxId"
                                    value={company.taxId || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="fw-semibold">Mail App Password</label>
                                <input
                                    className="form-control"
                                    name="smtpPassword"
                                    value={company.smtpPassword || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                        </div>

                        <div className="row g-4">

                            <div className="col-md-4">
                                <label className="fw-semibold">Address</label>
                                <textarea
                                    className="form-control"
                                    name="address"
                                    rows="2"
                                    value={company.address || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="fw-semibold">Description</label>
                                <textarea
                                    className="form-control"
                                    name="description"
                                    rows="2"
                                    value={company.description || ""}
                                    onChange={handleChange}
                                    disabled={mode === "view"}
                                />
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </>
    );
};

export default SettingsPage;

